



















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";
import Users from "@/store/modules/Users";
import DecisionTableView from "@/components/decisions/DecisionTableView.vue";
import Apps from '@/store/modules/Apps';

const decisionsModule = getModule(Decisions);
const usersModule = getModule(Users);
const appsModule = getModule(Apps);


@Component({
    components: {
        DecisionTableView
    }
})
export default class DecisionManager extends Vue {
    @Prop({ default: 'Decision', type: String })
    label: string;

    @Prop()
    plural: string;

    private dataLoaded = false;
    private searchTerm = '';
    private singleList = true;
    private ownedDecisions = [];
    private sharedDecisions = [];

    get decisions() {
        return Object.values(decisionsModule.decisions).sort((a: any, b: any) => {
            if (a.name === null || a.name === undefined) a.name = '';
            if (b.name === null || b.name === undefined) b.name = '';
            return a.name.localeCompare(b.name);
        });
    }

    get currentUserId() {
        if (usersModule.currentAuthUser) {
            return usersModule.currentAuthUser.username;
        }
    }

    get pluralLabel() {
        return this.plural ? this.plural : this.label + 's';
    }

    private newDecision() {
        this.$emit('newDecisionDialog', true);
    }

    @Watch('decisions', {immediate: true, deep: true})
    async decisionsChanged(newDecisions: any) {
        // console.log('decisionsChanged(newDecisions: any)');
        // console.log('newDecisions');
        // console.log(newDecisions);
        // console.log('this.decisions');
        // console.log(this.decisions);
        this.dataLoaded = false;
        this.ownedDecisions = [];
        this.sharedDecisions = [];
        for (const decision of newDecisions) {
            if (decision.ownerUserId == this.currentUserId) {
                this.ownedDecisions.push(decision);
            }
            else {
                this.sharedDecisions.push(decision);
            }
        }
        this.dataLoaded = true;
    }
}

